/**
 * Bridge for the process-wide active workspace (`set_active_workspace`).
 *
 * Rust-initiated backend requests bypass the web axios interceptor, so the
 * `Heidi-Workspace-Id` header has to come from Rust state. This pushes the
 * hydrated workspace id into the shared store in `utils::http_headers`;
 * every Rust client that builds requests with `heidi_headers()` reads it
 * (the engine cluster adopts it in this PR, remaining clients later in the
 * stack). Pass `null` on logout to clear it. Empty strings are treated as
 * unset.
 */
import { isTauri } from '@/tauri/utils';

export async function setActiveWorkspace(workspaceId: string | null): Promise<void> {
  if (!isTauri()) return;
  const { invoke } = await import('@tauri-apps/api/core');
  await invoke<void>('set_active_workspace', { workspaceId });
}
